import { useCallback } from "react";
import Header from "@/components/02-organisms/Header";
import { useIntl } from "react-intl";
import authMessages from "@/i18n/definitions/auth";
import langMessages from "@/i18n/definitions/languages";
import common from "@/i18n/definitions/common";
import { AppRoute } from "@/routes";
import { localizeRoutePath } from "@/modules/i18n/components/LocalizedSwitchUtils";
import Footer from "@/components/03-templates/Footer";
import { LocalesByLang, User } from "@/types";
import AlertMessage from "./components/00-atoms/Alert";

export const App = ({
  localesByLang,
  children,
  user
}: {
  children: any;
  localesByLang: LocalesByLang;
  user: User;
}): object => {
  const intl = useIntl();
  const { formatMessage, locale } = intl;

  const shortDescription = {
    text: formatMessage(common.siteShortDescription),
    path: "/"
  };

  const getHeader = useCallback(
    (template?: any) => {
      const authenticationLink = {
        text: !user
          ? [formatMessage(authMessages.logIn)]
          : [formatMessage(authMessages.logOut), user.username],
        path: !user
          ? localizeRoutePath(AppRoute.CasAuth, locale, intl)
          : localizeRoutePath(AppRoute.CasLogOut, locale, intl)
      };
      return (
        <Header
          inFinnish={"FI"}
          inSwedish={"SV"}
          isAuthenticated={!!user}
          locale={locale}
          localesByLang={localesByLang}
          logIn={formatMessage(authMessages.logIn)}
          authenticationLink={authenticationLink}
          shortDescription={shortDescription}
          template={template}
          languageSelectionAriaLabel={formatMessage(
            langMessages.selection
          )}></Header>
      );
    },
    [
      locale,
      localesByLang,
      formatMessage,
      shortDescription,
      user
    ]
  );

  const siteInfoBannerMessage = intl.formatMessage(
    common.siteInfoBannerMessage
  );

  return (
    <div className="flex flex-col min-h-screen">
      {/*Ruudunlukijoille skip to main content linkki*/}
      <a
        href={"#oiva-skip-nav"}
        data-oiva-skip-link=""
        data-oiva-skip-nav-link="">
        {formatMessage(common.jumpToContent)}
      </a>
      {getHeader()}
      {siteInfoBannerMessage !== "empty" && (
        <AlertMessage
          id="siteInfoBanner"
          isClosable={false}
          ariaLabel="Site info banner"
          message={siteInfoBannerMessage}
          variant={"filled"}
        />
      )}
      <main className="flex-1 flex flex-col">
        {/*Ruudunlukijoille skip to main content kohde*/}
        <div id="oiva-skip-nav" data-oiva-skip-nav-content=""></div>
        {children}
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
};
